export default "assets/images/logo_footer-4e7b3fa4.png";